import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/PetaniRTLD.css"; // Pastikan file CSS umum sudah terhubung
import axios from "axios";

const DetailRencanaTanam = () => {
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [tanggal, setTanggal] = useState("");
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleBack = () => {
    navigate("/petanirt");
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      alert("Gagal logout. Silakan coba lagi.");
    }
  };

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    // Ambil informasi user
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const resData = response.data;
        if (!resData.error) {
          setUserInfo({
            role: resData.role,
            name: resData.name,
            full_name: resData.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    // Fetch data detail
    const fetchDetailData = async () => {
      try {
        const response = await axios.get(
          `https://c-greenproject.org:7500/view_rencana_tanam_detail?id=${id}`,
          { withCredentials: true }
        );

        if (response.data && response.data.tanam) {
          setData(response.data.tanam);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDetailData();
  }, [id]);

  // Helper Warna Status Validasi
  const getStatusBadge = (status) => {
    const s = String(status || "").toLowerCase().trim();
    if (s === "approved" || s === "disetujui") {
      return <span className="badge bg-success-subtle text-success px-4 py-2 rounded-pill border border-success-subtle fw-semibold fs-6">Disetujui</span>;
    }
    if (s === "rejected" || s === "ditolak") {
      return <span className="badge bg-danger-subtle text-danger px-4 py-2 rounded-pill border border-danger-subtle fw-semibold fs-6">Ditolak</span>;
    }
    return <span className="badge bg-warning-subtle text-warning-emphasis px-4 py-2 rounded-pill border border-warning-subtle fw-semibold fs-6">Menunggu Validasi</span>;
  };

  // Komponen Label & Value Row Anti-Pecah
  const DetailRow = ({ label, value }) => (
    <div className="d-flex justify-content-between align-items-center py-3 border-bottom" style={{ gap: "20px" }}>
      <span className="text-muted fw-semibold text-nowrap">{label}</span>
      <span className="fw-bold text-dark text-end" style={{ wordBreak: "break-word" }}>{value || "-"}</span>
    </div>
  );

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light flex-column">
        <div className="text-center py-5 text-muted">
          <i className="fa fa-folder-open mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
          <h4 className="fw-bold text-dark">Data tidak ditemukan</h4>
          <p>Data detail rencana tanam yang Anda cari tidak tersedia.</p>
          <button className="btn btn-outline-secondary mt-3 rounded-pill px-4" onClick={handleBack}>
            Kembali ke Daftar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header bg-white shadow-sm border-bottom">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span className="fw-medium text-secondary" style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3 bg-white shadow-sm" id="sidebar">
          <p id="sidebar-title" className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 id="sidebar-subtitle" className="fw-bold text-success mb-3">Telsa Super Apps</h6>
          <p id="sidebar-date" className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2">
            <img src="/static/schedule_11145854.png" alt="Date" style={{ width: "16px" }} />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3" id="sidebar-menu">
            <div
              onClick={() => navigate("/petani")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petani" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petani" ? "brightness(0) invert(1)" : "none" }} /> Beranda
            </div>
            <div
              onClick={() => navigate("/petanirt")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname.includes("/petanirt") ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/Tanam.png" alt="Planting" style={{ width:"20px", marginRight:"10px", filter: location.pathname.includes("/petanirt") ? "brightness(0) invert(1)" : "none" }} /> Rencana Tanam
            </div>
            <div
              onClick={() => navigate("/petanirp")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanirp" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/panen.png" alt="Harvest" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petanirp" ? "brightness(0) invert(1)" : "none" }} /> Rencana Panen
            </div>
            <div
              onClick={() => navigate("/petanifp")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanifp" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/FinalPanen.png" alt="Final Panen" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petanifp" ? "brightness(0) invert(1)" : "none" }} /> Final Panen
            </div>
            <div
              onClick={() => navigate("/petanip")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanip" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/sell_8087698.png" alt="Sales" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petanip" ? "brightness(0) invert(1)" : "none" }} /> Penjualan
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          
          {/* Top Bar Area */}
          <div className="content-box mb-4 d-flex flex-column flex-md-row justify-content-between align-items-md-center">
            <div>
              <h3 className="fw-bold text-dark mb-1">Detail Rencana Tanam</h3>
              <p className="text-muted mb-0 font-monospace">ID Tanam: #{data.id}</p>
            </div>
            <div className="mt-3 mt-md-0">
              <button className="btn kembali-button rounded-pill px-4 fw-medium shadow-sm" onClick={handleBack}>
                <i className="fa fa-arrow-left me-2"></i>Kembali
              </button>
            </div>
          </div>

          <div className="row g-4">
            {/* Kolom Kiri: Informasi Lahan & Tanaman */}
            <div className="col-12 col-xl-7">
              <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white h-100">
                <h5 className="fw-bold text-success mb-4 pb-2 border-bottom">Informasi Lahan & Tanaman</h5>
                
                <DetailRow label="Nama Petani" value={data.nama} />
                <DetailRow label="Alamat Lahan" value={data.alamat} />
                <DetailRow label="Luas Lahan" value={data.luas_lahan ? `${data.luas_lahan} Hektar` : "-"} />
                <DetailRow label="Jenis Sawit" value={data.jenis_sawit} />
                <DetailRow label="Jumlah Tanam" value={data.jumlah_tanaman ? `${Number(data.jumlah_tanaman).toLocaleString("id-ID")} Pohon` : "-"} />
                <DetailRow label="Tanggal Tanam" value={data.tanggal_penanaman} />
                <DetailRow label="Jenis Pupuk" value={<span className="text-uppercase">{data.jenis_pupuk}</span>} />
              </div>
            </div>

            {/* Kolom Kanan: Status & Histori Validasi */}
            <div className="col-12 col-xl-5">
              <div className="content-box p-4 border-0 shadow-sm rounded-4 h-100" style={{ backgroundColor: "#fbfbfc" }}>
                <h5 className="fw-bold text-dark mb-4 pb-2 border-bottom">Status Validasi</h5>
                
                <div className="mb-4">
                  <p className="text-muted fw-semibold mb-2">Status Saat Ini</p>
                  <div>{getStatusBadge(data.status_validasi)}</div>
                </div>

                <div className="mb-4">
                  <p className="text-muted fw-semibold mb-1">Tanggal Pengajuan</p>
                  <p className="fw-bold text-dark fs-5">{data.tanggal_permohonan || "-"}</p>
                </div>

                <div className="mb-4">
                  <p className="text-muted fw-semibold mb-1">Tanggal Validasi</p>
                  <p className="fw-bold text-dark fs-5">{data.tanggal_persetujuan || "Belum diperiksa"}</p>
                </div>

                <div className="mb-0 pt-3 border-top">
                  <p className="text-muted fw-semibold mb-2">Catatan Validator</p>
                  <div className="bg-white p-3 rounded-3 border shadow-sm">
                    <p className="mb-0 fw-medium text-secondary" style={{ wordBreak: "break-word" }}>
                      {data.catatan || <span className="fst-italic text-muted">Tidak ada catatan tambahan.</span>}
                    </p>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default DetailRencanaTanam;